const dateOptions: Intl.DateTimeFormatOptions = {
  weekday: "long",
  year: "numeric",
  // Note: as of 2022-08-15 it was noticed that the long month notation adds the
  // work "at" when stringifying which mysteriously will not be properly reparsed.
  // "at" must be removed from the string or the format change to "short"
  month: "long",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  timeZoneName: "short",
};

export default dateOptions;
